<template>
    <div class="form">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex>
                        <v-layout row>
                            <div class="info-block">
                                User settings
                            </div>
                        </v-layout>
                        <v-layout row v-if="errors !== null">
                            <v-flex md12>
                                <div class="content-wrapper">
                                    <div class="error-block">
                                        <div class="title">Errors</div>
                                        <p v-html="errors"></p>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Speed Unit <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-select
                                    v-model="form.speedUnit"
                                    :items="getSpeedUnitTypes"
                                    label="Choose speed unit"
                                    item-text="name"
                                    item-value="id"
                                    required
                                    outline
                                    single-line
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs5>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Language <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs7>
                                <v-select
                                    v-model="form.language"
                                    :items="getLanguages"
                                    label="Choose language"
                                    item-text="key"
                                    item-value="id"
                                    required
                                    outline
                                    single-line
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout row class="buttons">
                            <v-flex xs7 class="right text-xs-right">
                                <sp-button @click.native="validate" :loading="isLoading" text="Save" icon="download"></sp-button>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import { mapGetters } from 'vuex'

export default {
    name: 'ProfileSettings',
    components: {
        SpButton
    },
    props: {
        handler: {
            type: Function,
            required: true
        },
        form: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            valid: false,
            errors: null,
            isLoading: false,
            rules: {
            }
        }
    },
    computed: {
        ...mapGetters('dictionaryModule', [
            'getSpeedUnitTypes',
            'getLanguages'
        ])
    },
    mounted () {
    },
    methods: {
        async validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }
            this.isLoading = true
            try {
                this.errors = null
                await this.handler(this.form)
            } catch (e) {
                this.errors = e.message
            }
            this.isLoading = false
            this.rePassword = null
        }
    }
}
</script>

<style scoped>
.form {
    width: 100%;
}
</style>
